import { Pipe, PipeTransform } from '@angular/core';
import { isDefined } from '@evorait/pace-core';
import { FormsConstants } from '../../types/forms-constants';
import { FormUtilities } from '../../utilities/form-utilities';

const isFormType = (value: string | undefined): value is FormsConstants.FORMTYPE =>
    isDefined(value) && (Object.values(FormsConstants.FORMTYPE) as string[]).includes(value);

@Pipe({
    name: 'docBoxReportType',
    standalone: false,
})
export class DocBoxReportTypePipe implements PipeTransform {
    public transform(value: string): string {
        // DOCBOX_TECHNICAL_NAME is keyed by the FORMTYPE value, so the reverse lookup already yields the form type
        const formType = Object.keys(FormsConstants.DOCBOX_TECHNICAL_NAME).find(
            (key) => FormsConstants.DOCBOX_TECHNICAL_NAME[key] === value,
        );

        if (!isFormType(formType)) {
            return '';
        }

        return FormUtilities.getTranslationKeyForFormType(formType);
    }
}
